import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { PerformanceTeamReview } from '../../models/performance-team-review.model';

@Component({
    selector: 'app-delete-performance-team-review-dialog',
    templateUrl: './delete-performance-team-review-dialog.component.html',
    styleUrls: ['./delete-performance-team-review-dialog.component.scss'],
    animations: fuseAnimations,
})
export class DeletePerformanceTeamReviewDialog extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    performanceTeamReview: PerformanceTeamReview;

    private _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    constructor(private _formBuilder: FormBuilder, public dialogRef: MatDialogRef<DeletePerformanceTeamReviewDialog>) {
        super();
    }

    ngOnInit(): void {
        // Initialize form group with custom validation
        this._formGroup = this._formBuilder.group({
            name: ['', [Validators.required, this.nameMatchValidator.bind(this)]],
        });
    }

    // Custom validator to check if form input matches performanceTeamReview.name
    nameMatchValidator(control: any) {
        return control.value === this.performanceTeamReview?.name ? null : { nameMismatch: true };
    }

    deletePerformanceTeamReview(): void {
        this.dialogRef.close(true);
    }
}
